import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { FacebookAudienceContext } from '@/features/editor/widgets/shared/modals/audience/facebook-audience/context';
import { VSpace } from '@/components/spacing';
import { QBTimeframeSuffix } from '@/components/query-builder/timeframe-suffix';

const Container = styled.div`
  width: 100%;
`;

export const Success: FC = () => {
  const { targeting } = useContext(FacebookAudienceContext);
  return (
    <Container>
      <StaticImage
        src="./nohead.svg"
        alt="success"
        placeholder="none"
        formats={[`webp`, `png`]}
        loading="eager"
        quality={100}
        height={100}
      />
      <VSpace value={2} />
      <SubTitle>
        The changes you make to this experience will only be shown to visitors
        from
      </SubTitle>
      <SelectContainer>
        <div style={{ width: `230px` }}>
          <QBTimeframeSuffix
            onChange={(timeframe) => {
              targeting.current = { ...targeting.current, timeframe };
            }}
            initialValue={targeting?.current?.timeframe}
          />
        </div>
      </SelectContainer>
      <VSpace />
      <TargetedEntities />
    </Container>
  );
};

const NamesContainer = styled.div`
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: 1rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    padding: 0 2rem;
    user-select: text;
    margin: 0.5rem 0;
  }

  span {
    user-select: text;
  }

  table {
    table-layout: fixed;
  }

  th,
  td {
    overflow-wrap: anywhere;
  }
`;

export const TargetedEntities: FC = () => {
  const { targeting } = useContext(FacebookAudienceContext);

  const { adsets } = targeting.current;
  const { ads } = targeting.current;
  const { campaigns } = targeting.current;
  return (
    <NamesContainer>
      <table style={{ width: `100%`, borderCollapse: `collapse` }}>
        <thead>
          <tr>
            <th style={{ padding: `1rem`, textAlign: `left` }}>Campaign</th>
            {(adsets?.length > 0 || ads?.length > 0) && (
              <th style={{ padding: `1rem`, textAlign: `left` }}>Ad Set</th>
            )}
            {ads?.length > 0 && (
              <th style={{ padding: `1rem`, textAlign: `left` }}>Ad</th>
            )}
          </tr>
        </thead>
        <tbody>
          {campaigns?.map((campaign) => (
            <tr key={campaign.id}>
              <td style={{ padding: `1rem`, textAlign: `left` }}>
                {campaign.name}
              </td>
              {(adsets?.length > 0 || ads?.length > 0) && (
                <td style={{ textAlign: `left` }} />
              )}
              {ads?.length > 0 && <td style={{ textAlign: `left` }} />}
            </tr>
          ))}
          {adsets?.map((adset) => (
            <tr key={adset.id}>
              <td style={{ padding: `1rem`, textAlign: `left` }}>
                {adset.campaignName}
              </td>
              {(adsets?.length > 0 || ads?.length > 0) && (
                <td style={{ padding: `1rem`, textAlign: `left` }}>
                  {adset.name}
                </td>
              )}
              {ads?.length > 0 && <td style={{ textAlign: `left` }} />}
            </tr>
          ))}
          {ads?.map((ad) => (
            <tr key={ad.id}>
              <td style={{ padding: `1rem`, textAlign: `left` }}>
                {ad.campaignName}
              </td>
              {(adsets?.length > 0 || ads?.length > 0) && (
                <td style={{ padding: `1rem`, textAlign: `left` }}>
                  {ad.adsetName}
                </td>
              )}
              {ads?.length > 0 && (
                <td style={{ padding: `1rem`, textAlign: `left` }}>
                  {ad.name}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </NamesContainer>
  );
};

const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SubTitle = styled.p`
  text-align: center;
  font-family: Inter, serif;
  font-size: 1.7rem;
  font-weight: 500;
`;
